import React, { useState } from 'react';
import { Divider } from '@leagueplatform/genesis-core';
import { AccordionData, Preference } from '../../../types/accordian.types';
import AccordionItem from './accordianItem';
import './accordian.css';

function Accordion({
  items,
  handleChange,
  result,
}: {
  items: Array<AccordionData>;
  handleChange: (x: {}) => void;
  result: Preference;
}) {
  const [currentIdx, setCurrentIdx] = useState(-1);
  const btnOnClick = (idx: number) => {
    setCurrentIdx((currentValue) => (currentValue !== idx ? idx : -1));
  };

  return (
    <ul
      style={{ listStyle: 'none', padding: '0px' }}
      data-testid="preference-container"
    >
      {items.map((item, idx) => (
        <AccordionItem
          key={item.title}
          handleChange={handleChange}
          data={item}
          result={result}
          isOpen={idx === currentIdx}
          btnOnClick={() => btnOnClick(idx)}
        />
      ))}
      {items && items.length > 0 && (
        <Divider aria-hidden={false} css={{ margin: '0px' }} />
      )}
    </ul>
  );
}

export default Accordion;
